import { useFlowStore } from '@/store/flowStore'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const ContactRoute = lazyRouteComponent(() => import('@/features/contact/Contact'), 'Contact')

export const Route = createFileRoute('/contato')({
  component: ContactRoute,
  beforeLoad: () => {
    const { completed, steps, index, selectedObjectives } = useFlowStore.getState()
    const hasCompletedFlow = completed || (steps.length > 0 && index >= steps.length)
    if (!hasCompletedFlow || selectedObjectives.length === 0) {
      throw redirect({ to: '/objetivo' })
    }
  },
})
